import React, {PureComponent} from "react"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {Row, Col} from "react-bootstrap"

import {Hr} from "@irati/ui/src/Layout"
import {QueryUsersArgs} from "@irati/identity/services/queries/usersForBusiness"
import Label from "../Menu/Label"
import FlexSpaceBetween from "./styled/FlexSpaceBetween"

export const ALL = "admin.components.alphabetSearch.all.text"
const alphabet = [ALL, ..."abcdefghijklmnopqrstuvwxyz".toUpperCase().split("")]

export type onAlphabet = (lastNameCharacter: string | null) => void

interface Props extends InjectIntl {
  onSearch: onAlphabet
  variables: QueryUsersArgs
}

interface State {
  selectedLetter: string | null
}

export class AlphabetSearch extends PureComponent<Props, State> {
  handleSearch = (letter: string) => {
    const selectedLetter = letter === ALL ? null : letter
    return this.props.onSearch(selectedLetter)
  }

  render() {
    const {formatMessage, variables} = this.props

    const selectedLetter = variables.lastNameCharacter

    return (
      <Row>
        <Col xs={12}>
          <FlexSpaceBetween>
            {alphabet.map((letter, index) => (
              <Label key={letter} onClick={() => this.handleSearch(letter)} selected={selectedLetter === letter}>
                {index === 0 ? formatMessage({id: letter}) : letter}
              </Label>
            ))}
          </FlexSpaceBetween>
          <Hr />
        </Col>
      </Row>
    )
  }
}

export default injectIntl(AlphabetSearch)
